<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="شكر-وتقدير">
<p><span dir="rtl">اصفح عني سيدي أو سيدتي إن بدأ الأمر مخيفاً، لكنه عكس هذا تماماً.</span></p>
<p><span dir="rtl">في حال شعرت بالدهشة؛ تشبث بالكتاب، لا تلقِ به فإنهُ ثمين؛ لأني قد وضعت شيئاً لا يعوض قُد رُصع بالكلمات بجوف كتابٍ يقتنى.</span></p><br/>
<p style="text-align:center; direction:ltr">Forgive me Sir, or Madame, if it looks scary, well it’s not.</p>
<p style="text-align:center; direction:ltr">So, in case you felt amazed, do not throw the book away hold it tight and do not let it fall because I’ve put my opinions in it, I’ve written my precious words deep in this book that I sell it.</p><br/>
<br/><p style="text-align:center">******</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?52266571